import React, { Component } from "react";
import FallBackUI from "./FallBackUI";
import { ERRORBOUND } from "../../constants"

interface ErrBoundProps {
  children?: any,
}

interface ErrBoundState {
  hasError?: boolean;
}

class ErrorBoundary extends Component<ErrBoundProps, ErrBoundState> {

  constructor(props: ErrBoundProps) {
    super(props)

    this.state = {
      hasError: false
    }
  }
  static getDerivedStateFromError(error: any) {
    return {
      hasError: true
    }
  }

  render() {
    if (this.state.hasError) {
      return <>{ERRORBOUND && <FallBackUI />}</>
    }
    return this.props.children
  }

}

export default ErrorBoundary